<template>
  <div class="loginAll">
    <div class="login" v-html="skiResortInfo">
      
    </div>
  </div>
</template>

<script>
  // 引入共用的css
	import "../components/css/component.css";
  import "../components/css/input.css";

  // 调用的接口
  import { getSkiResortInfo } from '@/request/api.js';
  
  export default {
    name: 'skiResortDetail',
    data () {
      return {
        skiResortInfo: '' // 详情
      }
    },

    mounted() {
      // 获取雪场详情
      this.getSkiResortDetail();
    },

    computed:{
      
    },

    methods:{
      // 获取雪场详情
      getSkiResortDetail() {
        // 用户点击雪场获取的id
        var skiResortId = localStorage.getItem('skiResortId');
        // 调用获取详情接口
        getSkiResortInfo({
          id: skiResortId // 雪场id
        }).then(res => {
          if(res.code === 0) {
            this.skiResortInfo = res.data.field_introduce;
          }
        })
      }
    }
  }
</script>

<!-- 样式 -->
<style scoped lang="scss">
  .loginAll {
    min-width: 1200px;
    // 框
    .login {
      width: 1200px;
      margin: 0 auto;
      text-align: justify;
      padding: 30px 0;
      &p {
        line-height: 22px;
      }
    }
  }
</style>



// WEBPACK FOOTER //
// src/components/skiResortDetail.vue